import { createContext, useContext } from "react";
export const LinkBehaviourContext = createContext(null);
export const useLink = () => {
    return useContext(LinkBehaviourContext);
};
//# sourceMappingURL=LinkBehaviourContext.js.map